import { create } from 'zustand'

import type { TClientReport } from '../types/home-client-report.type'
import type { TGoalReport } from '../types/home-goal-report.type'

type THomeStoreState = {
  dataGoalReport: TGoalReport | undefined
  dataClientReport: TClientReport[] | undefined
  typeDashboard: number
  isOpenModalUpdate: boolean
}

type THomeStoreAction = {
  setDataGoalReport: (dataGoalReport: TGoalReport | undefined) => void
  setDataClientReport: (dataClientReport: TClientReport[] | undefined) => void
  setTypeDashboard: (typeDashboard: number) => void
  setIsOpenModalUpdate: (isOpenModalUpdate: boolean) => void
}

type THomeStore = THomeStoreState & THomeStoreAction

export const useHomeStore = create<THomeStore>((set) => ({
  dataGoalReport: undefined,
  dataClientReport: undefined,
  typeDashboard: 5,
  isOpenModalUpdate: false,

  setDataClientReport: (dataClientReport) => set({ dataClientReport }),
  setDataGoalReport: (dataGoalReport) => set({ dataGoalReport }),
  setTypeDashboard: (typeDashboard) => set({ typeDashboard }),
  setIsOpenModalUpdate: (isOpenModalUpdate) => set({ isOpenModalUpdate }),
}))
